import { defineMessages } from 'react-intl';

/* eslint-disable perfectionist/sort-object-types */
export const messages: {
	menuLinkItemAriaLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	/* eslint-enable perfectionist/sort-object-types */
} = defineMessages({
	menuLinkItemAriaLabel: {
		id: 'navigation.global-shortcuts.shortcut-link-item.aria-label',
		description:
			'Accessibility label for individual app shortcut items in the global shortcuts menu. The placeholder {appName} is substituted with the application name (e.g., "Jira", "Confluence"), and {siteName} is substituted with the site name if applicable (e.g., " - Engineering"). Example: "Jira - Engineering". Assistive technologies use this label to announce the app and site context to users.',
		defaultMessage: '{appName}{siteName}',
	},
});

export const menuErrorMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.global-shortcuts.error.header',
		defaultMessage: 'We couldn’t load the shortcut for {menuId}',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.global-shortcuts.error.description',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});
